import { Helmet } from '@dr.pogodin/react-helmet';
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

const SEO = ({
  pageTitle = "R'Rumi Diamond - Luxury Diamond Jewelry",
  metaDescription = "Exquisite handcrafted diamond jewelry including engagement rings, wedding bands, and luxury accessories. Certified diamonds with lifetime warranty.",
  metaKeywords = [
    "R'Rumi Diamond",
    "diamond jewelry",
    "engagement rings",
    "wedding bands", 
    "luxury jewelry",
    "certified diamonds",
    "precious gemstones"
  ],
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogImage = "https://rrumidiamond.co/images/default-social.jpg",
  ogType = "website", 
  twitterCard = "summary_large_image",
  children,
}) => {
  const location = useLocation();

  // Generate canonical URL - handle trailing slashes and query params
  const currentPath = location.pathname.replace(/\/+$/, "") + location.search;
  const finalCanonical = canonicalUrl || `https://rrumidiamond.co${currentPath}`;

  // Optimized fallbacks for social meta
  const finalOgTitle = ogTitle || `${pageTitle} | Certified Luxury Jewelry`;
  const finalOgDescription = ogDescription || 
    `${metaDescription.substring(0, 155)}...`;
console.log(ogImage,"ogImage")
  return (
    <Helmet>
      <html lang="en" />
      
      {/* Primary Meta Tags */}
      <title>{pageTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={[...new Set(metaKeywords)].join(", ")} />
      <link rel="canonical" href={finalCanonical} />
      <meta name="image" content={ogImage} />

      {/* Technical SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="R'Rumi Diamond" />
      <meta name="publisher" content="R'Rumi Diamond" />
      <meta name="copyright" content={`© ${new Date().getFullYear()} R'Rumi Diamond`} />
      <meta name="format-detection" content="telephone=no" />
      
      {/* Mobile Optimization */}
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-title" content="R'Rumi Diamond" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="theme-color" content="#000000" />
      <meta name="msapplication-TileColor" content="#000000" />
      <meta name="application-name" content="R'Rumi Diamond" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:description" content={finalOgDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={finalOgTitle} />
      <meta property="og:url" content={finalCanonical} />
      <meta property="og:site_name" content="R'Rumi Diamond" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:updated_time" content={new Date().toISOString()} />

      {/* Twitter Card */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={finalOgTitle} />
      <meta name="twitter:description" content={finalOgDescription} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:image:alt" content={finalOgTitle} />
      <meta name="twitter:site" content="@rrumidiamond" />
      <meta name="twitter:creator" content="@rrumidiamond" />

      {/* Performance Optimizations */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link rel="dns-prefetch" href="https://rrumidiamond.co" />
      
      {/* Structured Data and Additional SEO */}
      {children}
    </Helmet>
  );
};

SEO.propTypes = {
  pageTitle: PropTypes.string,
  metaDescription: PropTypes.string,
  metaKeywords: PropTypes.arrayOf(PropTypes.string),
  canonicalUrl: PropTypes.string,
  ogTitle: PropTypes.string,
  ogDescription: PropTypes.string,
  ogImage: PropTypes.string,
  ogType: PropTypes.oneOf(["website", "article", "product"]),
  twitterCard: PropTypes.oneOf(["summary", "summary_large_image", "app", "player"]),
  children: PropTypes.node,
};

SEO.defaultProps = {
  ogType: "website",
  twitterCard: "summary_large_image"
};

export default SEO;